import { render, staticRenderFns } from "./Chapter_2.vue?vue&type=template&id=62c8f660&scoped=true&lang=pug&"
import script from "./Chapter_2.vue?vue&type=script&lang=js&"
export * from "./Chapter_2.vue?vue&type=script&lang=js&"
import style0 from "./Chapter_2.vue?vue&type=style&index=0&id=62c8f660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c8f660",
  null
  
)

export default component.exports